import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead, { FAQPageSchema } from '@/components/feature/SEOHead';
import { categories } from '@/mocks/categories';
import { getHotVideos, getLatestVideos, type VideoItem } from '@/mocks/videos';
import { getLatestArticles, type Article } from '@/mocks/articles';

const FEATURED_VIDEOS: VideoItem[] = [
  {
    id: 'v005',
    title: '《长安十二时辰》全集：盛世之下的暗流涌动',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20cinematic%20scene%20of%20ancient%20Chinese%20Tang%20Dynasty%20cityscape%20at%20dusk%2C%20grand%20palace%20architecture%20with%20warm%20lantern%20lights%2C%20dramatic%20clouds%20in%20the%20sky%2C%20epic%20historical%20drama%20atmosphere%2C%20rich%20warm%20golden%20and%20red%20tones%2C%20cinematic%20composition&width=1600&height=700&seq=hero-banner-001&orientation=landscape',
    duration: '45:00',
    views: 1890000,
    category: 'sigua',
    categoryName: '丝瓜视频',
    description: '豆瓣高分古装悬疑剧，惊心动魄的阴谋正在展开',
    publishDate: '2026-07-20',
    tags: ['古装', '悬疑', '热剧'],
  },
  {
    id: 'v011',
    title: '《狂飙》未删减版：扫黑风云再起',
    cover: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20cinematic%20scene%20with%20police%20officers%20and%20dark%20city%20skyline%2C%20dramatic%20rainy%20night%20atmosphere%2C%20powerful%20composition%2C%20professional%20TV%20drama%20aesthetic%2C%20deep%20shadows%20and%20warm%20street%20lights&width=1600&height=700&seq=hero-banner-002&orientation=landscape',
    duration: '48:00',
    views: 5670000,
    category: 'sigua',
    categoryName: '丝瓜视频',
    description: '年度现象级扫黑剧，黑白较量终极对决',
    publishDate: '2026-07-10',
    tags: ['扫黑', '犯罪', '热剧'],
  },
  {
    id: 'v004',
    title: '《快乐大本营2026》当红明星爆笑挑战',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20variety%20show%20stage%20with%20celebrities%20and%20energetic%20atmosphere%2C%20professional%20TV%20studio%20lighting%2C%20vibrant%20colors%2C%20entertaining%20composition%2C%20cheerful%20and%20exciting%20mood&width=1600&height=700&seq=hero-banner-003&orientation=landscape',
    duration: '68:20',
    views: 2350000,
    category: 'mangguo',
    categoryName: '芒果视频',
    description: '当红明星爆笑挑战，精彩互动笑料百出',
    publishDate: '2026-07-31',
    tags: ['综艺', '明星', '搞笑'],
  },
];

const FAQ_ITEMS = [
  {
    question: '茄子视频是什么？',
    answer: '茄子视频是一个聚合型在线影视平台，汇集西瓜视频、糖豆视频、小蓝视频、芒果视频、丝瓜视频、蓝莓视频等多个视频源，为用户提供一站式的视频浏览和观看体验，所有内容均免费高清在线观看。',
  },
  {
    question: '茄子视频如何观看视频？',
    answer: '您可以通过分类浏览找到感兴趣的视频内容，点击即可在线观看。我们提供西瓜视频、糖豆视频、小蓝视频、芒果视频、丝瓜视频、蓝莓视频六大频道，涵盖搞笑娱乐、舞蹈健身、科技知识、热门综艺、热播剧集和纪录探索等多种内容类型。',
  },
  {
    question: '茄子视频是否需要注册或付费？',
    answer: '茄子视频目前完全免费，无需注册登录即可浏览和观看所有视频内容。我们致力于为用户提供最便捷的视频聚合服务，让您轻松畅享高清在线影视。',
  },
  {
    question: '茄子视频支持哪些设备观看？',
    answer: '茄子视频支持电脑、平板、手机等多种设备观看，自适应不同屏幕尺寸，随时随地享受高清视频体验。',
  },
  {
    question: '茄子视频的内容多久更新一次？',
    answer: '茄子视频的内容每日更新，各频道持续同步最新视频资源。我们的编辑团队精心筛选优质内容，确保您每次访问都能发现新鲜有趣的视频。',
  },
];

export default function Home() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const hotVideos = getHotVideos(8);
  const latestVideos = getLatestVideos(8);
  const latestArticles = getLatestArticles(6);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % FEATURED_VIDEOS.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const banner = FEATURED_VIDEOS[currentBanner];

  return (
    <>
      <SEOHead
        title="茄子视频 - 在线影视平台 | 西瓜视频 糖豆视频 小蓝视频 芒果视频 丝瓜视频 蓝莓视频 高清免费在线观看"
        description="茄子视频聚合在线影视平台、视频直播网站、在线看剧网站，提供西瓜视频、糖豆视频、小蓝视频、芒果视频、丝瓜视频、蓝莓视频等高清免费在线观看。"
        keywords="茄子视频,在线影视平台,视频直播网站,在线看剧网站,西瓜视频,糖豆视频,小蓝视频,芒果视频,丝瓜视频,蓝莓视频,高清免费,在线观看"
        canonicalUrl="https://qiezi.video"
      />
      <FAQPageSchema questions={FAQ_ITEMS} />

      <main>
        <Navbar transparent />

        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          {FEATURED_VIDEOS.map((video, idx) => (
            <div
              key={video.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                idx === currentBanner ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={video.cover}
                alt={video.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl">
                <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
                  {banner.categoryName}
                </span>
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 mb-4 leading-tight">
                  {banner.title}
                </h1>
                <p className="text-sm md:text-base text-background-50/80 mb-6 max-w-xl">
                  {banner.description}
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                  <Link
                    to={`/article/${banner.id}`}
                    className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-primary-600 cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-play-fill text-lg"></i>
                    立即观看
                  </Link>
                  <div className="flex items-center gap-4">
                    <span className="text-xs text-background-50/60">
                      <i className="ri-time-line mr-1"></i>{banner.duration}
                    </span>
                    <span className="text-xs text-background-50/60">
                      <i className="ri-eye-line mr-1"></i>{(banner.views / 10000).toFixed(1)}万次
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 mt-8">
                  {FEATURED_VIDEOS.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentBanner(idx)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                        idx === currentBanner ? 'bg-primary-500 w-6' : 'bg-background-50/40'
                      }`}
                      aria-label={`切换到第${idx + 1}张`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={() => setCurrentBanner((currentBanner - 1 + FEATURED_VIDEOS.length) % FEATURED_VIDEOS.length)}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 transition-colors duration-200 cursor-pointer"
            aria-label="上一张"
          >
            <i className="ri-arrow-left-s-line text-background-50 text-lg"></i>
          </button>
          <button
            onClick={() => setCurrentBanner((currentBanner + 1) % FEATURED_VIDEOS.length)}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 transition-colors duration-200 cursor-pointer"
            aria-label="下一张"
          >
            <i className="ri-arrow-right-s-line text-background-50 text-lg"></i>
          </button>
        </section>

        {/* Category Quick Nav */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                六大频道 · 精彩纷呈
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                聚合西瓜视频、糖豆视频、小蓝视频、芒果视频、丝瓜视频、蓝莓视频，覆盖搞笑娱乐、舞蹈健身、科技知识、热门综艺、热播剧集和纪录探索
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer text-center"
                >
                  <div className={`w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-gradient-to-br ${cat.color}`}>
                    <i className={`${cat.icon} text-background-50 text-lg md:text-xl`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 font-heading">{cat.name}</h3>
                  <p className="text-xs text-foreground-500">{cat.videoCount.toLocaleString()}个视频</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-600">全网最受欢迎的视频内容</p>
              </div>
              <Link
                to="/category/xigua"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {hotVideos.map((video, idx) => (
                <VideoCard key={video.id} video={video} index={idx} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Videos */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                  <i className="ri-time-line text-primary-500 mr-2"></i>
                  最新更新
                </h2>
                <p className="text-sm text-foreground-600">每日持续更新，发现新鲜内容</p>
              </div>
              <Link
                to="/category/sigua"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {latestVideos.map((video, idx) => (
                <VideoCard key={video.id} video={video} index={idx} />
              ))}
            </div>
          </div>
        </section>

        {/* Articles */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                精选文章
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                深度内容，行业观察，健康养生，科技前沿，与你分享精彩世界
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 cursor-pointer video-card"
                >
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={article.cover}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="text-xs px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                      <span className="text-xs text-foreground-500 ml-auto whitespace-nowrap">
                        <i className="ri-time-line mr-1"></i>{article.readTime}分钟
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-2 mt-3 text-xs text-foreground-500">
                      <span>{article.author}</span>
                      <span>·</span>
                      <span>{article.publishDate}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 bg-primary-500">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {[
                { icon: 'ri-play-circle-line', value: '18,939', label: '视频总数' },
                { icon: 'ri-user-line', value: '5,280万+', label: '累计用户' },
                { icon: 'ri-eye-line', value: '86亿+', label: '累计播放' },
                { icon: 'ri-thumb-up-line', value: '99.2%', label: '好评率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                    <i className={`${stat.icon} text-background-50 text-lg md:text-xl`}></i>
                  </div>
                  <div className="text-xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
                  <div className="text-xs md:text-sm text-background-50/70 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                快速了解茄子视频的使用方式
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {FAQ_ITEMS.map((faq, idx) => (
                <FAQItem key={idx} question={faq.question} answer={faq.answer} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
              准备好开始观看了吗？
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-xl mx-auto">
              汇聚六大视频平台优质内容，高清免费在线观看，随时随地享受精彩视频
            </p>
            <Link
              to="/category/xigua"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-play-fill text-lg"></i>
              立即开始观看
            </Link>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}

function VideoCard({ video, index }: { video: VideoItem; index: number }) {
  const bgClass = index % 2 === 0 ? 'bg-background-50' : 'bg-background-50';

  return (
    <Link
      to={`/article/${video.id}`}
      className={`group ${bgClass} rounded-lg overflow-hidden transition-all duration-300 cursor-pointer video-card`}
    >
      <div className="relative aspect-[16/9] overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="video-card-overlay absolute inset-0 bg-black/30 opacity-0 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-play-fill text-background-50 text-xl"></i>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
          {video.duration}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i> {(video.views / 10000).toFixed(1)}万
          </span>
          <span className="whitespace-nowrap">{video.categoryName}</span>
        </div>
      </div>
    </Link>
  );
}

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg bg-background-100 overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full px-5 py-4 flex items-center justify-between cursor-pointer text-left"
      >
        <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">{question}</span>
        <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 text-lg flex-shrink-0 transition-transform duration-300`}></i>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          open ? 'max-h-48 pb-4' : 'max-h-0'
        }`}
      >
        <p className="px-5 text-sm text-foreground-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}